module.exports = __webpack_public_path__ + "img/stolik-2.758f6277.jpg";